import DashboardTabbedSection from "containers/Dashboard/components/dashboardSection/DashboardTabbedSection";
import DashboardSectionTab from "containers/Dashboard/components/dashboardSection/DashboardSectionTab";
import { Equipments } from "./subsections/Equipments";
import __ from "utils/i18n";

export const Standalone = () => {
  return (
    <DashboardTabbedSection>
        <DashboardSectionTab
          path="equipments"
          title={__("dashboard.sections.standalone.title")}
        >
          <Equipments />
        </DashboardSectionTab>
    </DashboardTabbedSection>
  );
};
